<template>
  <div v-if="type == 'template'">
    <k-autocomplete
    :label="label"
    :item-text="(item) => { return get_title(item) }"
    item-value="id"
    v-model="val"
    :items="filtered_items"
    append-outer-icon="fa-plus"
    @click:append-outer="add_channel"
    @change="add_channel"
    v-if="!is_readonly">
    </k-autocomplete>

    <span v-for="(item, i) in channels">
      <k-chip color="primary" size="s" :close="!is_readonly" @click:close="remove_channel(i)" v-if="item_visible(item)">
        {{get_title(item)}}
      </k-chip>
    </span>

  </div>

  <div v-else>
   <k-autocomplete
    :label="label"
    :item-text="(item) => { return get_title(item) }"
    item-value="id"
    v-model="val"
    :items="filtered_items"
    append-outer-icon="fa-plus"
    @click:append-outer="add_channel"
    @change="add_channel">
    </k-autocomplete>

    <span v-for="(channel, i) in channels">
      <k-chip color="primary" size="s" close @click:close="remove_channel(i)" v-if="item_visible(channel)">
        {{get_title(channel)}}
      </k-chip>
    </span>
  </div>

</template>

<script>
import ChannelModel from '@/models/channel.js'

export default {
  props: ["id", "type", "value", "label", "mode"],
  data () {
    var ch = this.$cloudserver.channel("channels:channel_group_channels:"+this.id);
    return {
      ws_channel: ch,
      channels: this.convertChannels(ch.data),
      val: undefined,
      expiry_time: -1
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.channels = this.convertChannels(newVal, oldVal);
        }
      },
      deep: true
    },
    channels(newVal) {
      this.$emit("input", newVal);
    }
  },
  created () {
    this.ws_channel.join();
  },
  computed: {
    items() {
      return ChannelModel.list_active_channels();
    },
    filtered_items() {
      return _.filter(this.items, (item) => {
        return _.isEmpty(_.find(this.channels, (i) => { return i.id == item.id; }));
      })
    }
  },
  methods: {
    is_readonly() {
      return this.mode == "readonly";
    },
    get_item(id) {
      return _.find(this.channels, (i) => { return i.id == id })
    },
    item_visible(item) {
      return !_.isEmpty(this.get_item(item.id));
    },
    get_title(item) {
      return ChannelModel.title(item.id);

      var item = this.get_item(item.id);
      if(this.type == "template") {
        return _.get(item, "title", "") + " (W: " + _.get(item, "meta.weight", 0) + ")";
      }
      return _.get(item, "title", "");
    },
    add_channel(item) {
      var self = this;
      if (typeof(this.val) != "undefined" && this.val != null && _.isEmpty(_.find(this.channels, (i) => { return i == this.val; }))) {
        this.channels.push({id: this.val, expiry_time: this.expiry_time});
      }
      this.$nextTick(function() {
//        self.val = undefined;
      });
    },
    remove_channel(idx) {
      if (!this.is_readonly()) {
        this.channels.splice(idx, 1);
      }
    },
    convertChannels(newVal, oldVal) {
      var channels = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }

      if(typeof(channels) == "undefined" || _.isEmpty(channels)) return [];
      return channels;
    }
  }
}
</script>